import React  from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import tokenStorage from 'utils/tokenStorage';

const PublicRoute = () => {

	const { role } = useSelector(state => state.auth)

	const sessionRole = tokenStorage.getItem('user_role');
	if (role || sessionRole) {
		const normalizedRole = (role || sessionRole || '').toLowerCase();
		let redirectPath;
		if (normalizedRole === 'agent') {
			redirectPath = `${APP_PREFIX_PATH}/agent/dashboard`;
		} else if (normalizedRole === 'client') {
			redirectPath = `${APP_PREFIX_PATH}/client/dashboard`;
		} else if (normalizedRole === 'admin') {
			redirectPath = `${APP_PREFIX_PATH}/dashboards/admin`;
		} else if (normalizedRole === 'manager' || normalizedRole === 'staff') {
			redirectPath = `${APP_PREFIX_PATH}/dashboards/user`;
		} else {
			// Default fallback
			redirectPath = `${APP_PREFIX_PATH}/dashboards/user`;
		}
		return <Navigate to={redirectPath} replace />;
	}

	return <Outlet />;
}

export default PublicRoute